import { CircleAlert, Inbox, RotateCcw } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { Botao } from './Botao';

/** Bloco cinza animado enquanto os dados carregam. */
export function Esqueleto({ className }: { className?: string }) {
  return (
    <div className={cn('animate-pulse rounded-md bg-superficie-2', className)} aria-hidden="true" />
  );
}

/** Carregamento com esqueletos + aviso para leitor de tela. */
export function Carregando({
  linhas = 3,
  rotulo = 'Carregando…',
}: {
  linhas?: number;
  rotulo?: string;
}) {
  return (
    <div role="status" className="flex flex-col gap-2">
      <span className="sr-only">{rotulo}</span>
      {Array.from({ length: linhas }, (_, i) => (
        <Esqueleto key={i} className="h-5 w-full" />
      ))}
    </div>
  );
}

/** Quando não há nada para mostrar: explica e sugere a próxima ação. */
export function EstadoVazio({
  titulo,
  descricao,
  acao,
}: {
  titulo: string;
  descricao?: string;
  acao?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-borda p-10 text-center">
      <Inbox className="size-10 text-texto-suave" aria-hidden="true" />
      <p className="font-semibold text-texto">{titulo}</p>
      {descricao && <p className="max-w-md text-sm text-texto-suave">{descricao}</p>}
      {acao}
    </div>
  );
}

/** Quando algo deu errado: mensagem humana + "tentar novamente". */
export function EstadoErro({
  titulo = 'Não foi possível carregar.',
  descricao = 'Verifique sua conexão e tente novamente.',
  aoTentarNovamente,
}: {
  titulo?: string;
  descricao?: string;
  aoTentarNovamente?: () => void;
}) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-3 rounded-xl border border-perigo/40 bg-perigo-fundo p-8 text-center"
    >
      <CircleAlert className="size-10 text-perigo" aria-hidden="true" />
      <p className="font-semibold text-perigo">{titulo}</p>
      <p className="text-sm text-texto">{descricao}</p>
      {aoTentarNovamente && (
        <Botao variante="contorno" onClick={aoTentarNovamente}>
          <RotateCcw className="size-4" aria-hidden="true" />
          Tentar novamente
        </Botao>
      )}
    </div>
  );
}
